// Rapportera dokumenthöjden till föräldersidan.
//
// Benders bäddar in beräkningsprogrammen med
//   <iframe src="..." width="100%" height="1350" scrolling="no">
// dvs. fast höjd och ingen inre scroll. När antalet brunnar ändras växer
// formuläret och skulle annars klippas. Föräldern lyssnar på
// 'benders:resize' och sätter iframe.style.height.

const RESIZE_MESSAGE = 'benders:resize'

function measure() {
  const body = document.body
  const html = document.documentElement
  // I en iframe med fast höjd kan documentElement låsas till viewporten,
  // så vi tar det största av body och html.
  return Math.ceil(
    Math.max(
      body ? body.scrollHeight : 0,
      body ? body.offsetHeight : 0,
      html ? html.scrollHeight : 0
    )
  )
}

export function startHeightReporting() {
  // Ingen förälder att rapportera till – kör vi fristående är detta en no-op.
  if (window.parent === window) return () => {}

  let lastHeight = 0

  const post = () => {
    const height = measure()
    // Undvik att spamma föräldern på sub-pixelskillnader.
    if (Math.abs(height - lastHeight) < 2) return
    lastHeight = height
    window.parent.postMessage({ type: RESIZE_MESSAGE, height }, '*')
  }

  // body växer med innehållet även när html är låst till viewporten.
  const observer = new ResizeObserver(post)
  observer.observe(document.body)

  window.addEventListener('load', post)
  window.addEventListener('resize', post)

  post()

  return () => {
    observer.disconnect()
    window.removeEventListener('load', post)
    window.removeEventListener('resize', post)
  }
}
